import { Grid, IconButton, Typography} from '@mui/material';
import React, {useEffect} from 'react';
import {makeStyles} from '@mui/styles';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {hasOneOfPermission, Permissions, user} from '../../../store/reducers/user';
import Formatter from '../../../util/formatter';
import * as _set from 'lodash/set';
import moment from 'moment';
import config from '../../../app/config';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SepsisPathwayFormRow from './components/sepsisPathwayFormRow';
import SepsisPathwayFormRowPaed from './components/sepsisPathwayFormRowPaed';
import useOpenState from '../../../hooks/useOpenState';
import AgyleDialog from '../../../components/modal/agyleDialog';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import {setBlockContext} from '../../../store/reducers/globals';
import InformationBox from '../../../components/other/informationBox';
import AgyleCheckBox from '../../../components/ui/checkbox/agyleCheckBox';
import {SepsisPathwayStatus} from './sepsisUtil';

export const useSepsisFromStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: -6,
        padding: 10,
    },
    backgroundModal: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        opacity: '0.7',
        zIndex: 99,
    },
    closeIcon: {
        position: 'absolute',
        right: '3px',
        top: '4px',
    },
    checked: {
        background: '#69BB69',
        padding: '10px 20px',
        maxWidth: '280px',
        borderRadius: '10px',
        backgroundColor: theme.palette.background.paper,
        marginTop: 20,
    },
    checkedName: {
        fontWeight: 'bold',
    },
    checkedBody: {
        height: '62px',
        display: 'table-cell',
        verticalAlign: 'middle',
        borderRadius: '10px',
        backgroundColor: theme.palette.background.paper,
    },
    switchBox: {
        flexBasis: 'content',
        minWidth: '220px',
        maxWidth: '220px',
    },
    required: {
        width: '100%',
        height: '100%',
    },
    checkBtn: {
        width: '66%',
        height: '35px',
        background: '#C33131',
        display: 'inline-block',
        textAlign: 'center',
        lineHeight: '35px',
    },
    naBtn: {
        width: '34%',
        height: '35px',
        background: '#FFA500',
        display: 'inline-block',
        textAlign: 'center',
        lineHeight: '35px',
    },
    activeBtn: {
        cursor: 'pointer',
    },
    timer: {
        marginTop: 5,
        marginRight: 10,
        height: '35px',
        lineHeight: '25px',
        textAlign: 'center',
        maxWidth: 'min-content',
    },
    notRequired: {
        background: '#FFA500',
        textAlign: 'center',
        padding: '10px 20px',
        maxWidth: '280px',
        borderRadius: '10px',
        backgroundColor: theme.palette.background.paper,
    },
    footer: {
        width: '100%',
        marginTop: '40px',
    },
    fullWidth: {
        width: '100%',
    },
    cancel: {
        background: 'indianred',
        color: 'white',
    },
    pathwayRow: {
        height: '90px',
        marginBottom: '10px',
        display: 'flex',
    },
    pathwayTitle: {
        display: 'inline-flex',
        height: '100%',
        width: 'calc(100% - 280px)',
    },
    pathwayActions: {
        width: '100%',
        maxWidth: '210px',
        marginTop: '5px',
        marginBottom: '5px',
        display: 'flex',
        marginRight: 15,
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
    },
    headerTitle: {
        textAlign: 'center',
        padding: '10px 25px',
        fontSize: '22px',
        backgroundColor: theme.palette.background.paper,
        marginBottom: '15px',
        borderRadius: '10px',
    },
    headerSubtitle: {
        fontSize: '16px',
        padding: '5px 25px',
        marginTop: '-10px',
        backgroundColor: '#a1a1a1',
    },
    pathNumber: {
        backgroundColor: theme.palette.mode === 'dark' ? '#FFFFFF' : '#bfc2c7',
        color: '#222425',
        fontWeight: 'bold',
        fontSize: 16,
        borderRadius: 6,
        width: 40,
        height: 40,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    pathDescription: {
        paddingLeft: '15px',
        paddingRight: '15px',
        display: 'inline-block',
    },
    subjectBox: {
        display: 'flex',
        alignItems: 'flex-start',
        paddingLeft: 10,
        paddingTop: 10,
    },
    subject: {
        fontSize: '16px',
        fontWeight: '500',
        marginLeft: 10,
    },
    reasonModal: {
        width: '400px',
        background: theme.palette.background.default,
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '10px 20px',
        marginTop: 'calc(50vh - 100px)',
    },
    reasonTexField: {
        width: '100%',
    },
    neuroSepsis: {
        background: '#FFA500',
        color: '#333',
        textAlign: 'center',
    },
    neuroWarning: {
        marginTop: 10,
        padding: 5,
        textAlign: 'center',
        color: '#333',
        background: '#dd7e6b',
        fontWeight: 'bold',
        fontSize: 'larger',
    },
    tep: {
        background: theme.palette.background.default,
        paddingBottom: 10,
        marginLeft: 16,
    },
    paedsAdditionalInfo: {
        background: '#C33131',
        color: '#FFFFFF',
        textAlign: 'center',
        paddingTop: '5px',
        paddingBottom: '5px',
        borderRadius: '10px',
        marginBottom: '10px',
    },
    infoBox: {
        background: '#ffd966',
        marginTop: 10,
        padding: 5,
        paddingLeft: 15,
        borderRadius: 8,
        fontWeight: 'bold',
        color: 'black',
    },
    infoBoxTitle: {
        borderBottom: `1px solid ${theme.palette.background.paperHover}`,
        paddingLeft: '10px',
        fontWeight: 'bold',
    },
    infoBoxRow: {
        paddingLeft: '10px',
        paddingRight: '10px',
    },
    infoBoxBullet: {
        fontSize: '24px',
    },
    sepsisRow: {
        width: '100%',
        background: theme.palette.background.paperDarker,
        borderRadius: 8,
        padding: 20,
        boxShadow: `0px ${theme.palette.mode === 'light' ? 4 : 0}px ${theme.palette.mode === 'light' ? 4 : 0}px 0px rgba(0, 0, 0, 0.25)`,
    },
    sepsisRowInfoBox: {
        margin: '15px 0',
        borderRadius: 8,
        border: `1px solid ${theme.palette.mode === 'dark' ? '#626466' : '#D2D5D9'}`,
        backgroundColor: theme.palette.mode === 'dark' ? '#3D3E40' : '#EFF1F3',
        padding: 5,
        width: 'fit-content',
    },
    reassessRow: {
        padding: '10px',
        background: theme.palette.background.paperDarker,
        borderRadius: '10px',
        justifyContent: 'space-between',
    },
    reassessCheckboxSection: {
        flexBasis: 'content',
        marginRight: '20px',
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    headerButtons: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginTop: 7,
        marginBottom: 7,
        paddingRight: 8,
        paddingBottom: 5,
    },
    sepsisTitle: {
        fontWeight: 'bold',
        fontSize: 16,
    },
    sepsisCreator: {
        fontSize: 12,
        marginLeft: 45,
        color: theme.palette.admissionForm.textColor,
    },
    divider: {
        margin: 5,
        width: '100%',
    },
    backButton: {
        marginRight: 5,
        backgroundColor: theme.palette.mode === 'dark' ? '#313233' : '#DEE1E5',
    },
    sepsisToggle: {
        padding: 12,
        '&.border': {
            borderRadius: 6,
            backgroundColor: theme.palette.mode === 'dark' ? '#222425' : '#DEE1E5',
        },
    },
    toggleRoot: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#EFF1F3' : '#494B4C',
        color: theme.palette.mode === 'light' ? '#ACAFB3' : '#2180F7',
    },
    toggleSelect: {
        '&&': {
            backgroundColor: '#2180F7',
            color: theme.palette.mode === 'light' ? '#FFF' : '#313233',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#2180F7',
                color: theme.palette.mode === 'light' ? '#FFF' : '#313233',
            },
        },
        '&.Mui-disabled': {
            backgroundColor: '#929292',
            border: 'none',
        },
    },
    toggleText: {
        marginTop: 10,
        fontSize: 14,
        color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#4f4d4d',
    },
    rows: {
        gap: 10,
        paddingTop: 16,
    }
}));

const sepsisDict = [
    {
        number: 0,
        subtitle: 'Make a treatment escalation plan and decide on CPR status',
        description: 'Inform ST3 or above (use SBAR) patient has Red Flag Sepsis',
        field: 'informST3',
    },
    {
        number: 1,
        subject: 'ADMINISTER OXYGEN',
        subtitle: 'Aim to keep saturations >94%',
        description: '(88-92% if at risk of CO2 retention e.g. COPD)',
        subDescription: '',
        field: 'oxygen',
    },
    {
        number: 2,
        subject: 'TAKE BLOOD CULTURES',
        subtitle: 'At least a peripheral set. Consider e.g. CSF, wound swab, sputum. Think source control!',
        description: 'Call surgeon/radiologist if needed. CXR and urinalysis for all adults',
        subDescription: '',
        field: 'bloods',
    },
    {
        number: 3,
        subject: 'GIVE IV ANTIBIOTICS',
        subtitle: 'According to Trust protocol',
        description: 'Consider allergies prior to administration',
        subDescription: '',
        field: 'antibiotics',
    },
    {
        number: 4,
        subject: 'GIVE IV FLUIDS',
        subtitle: 'If hypotensive OR lactate >2mmol/L: give 500ml over less than 15 min without delay.',
        description: 'Consider futher 20ml/kg if no response.',
        subDescription: 'If lactate <2 mmol/L: consider iv fluids',
        field: 'fluids',
    },
    {
        number: 5,
        subject: 'CHECK SERIAL LACTATES',
        subtitle: 'Corroborate high VBG lactate with arterial sample',
        description: 'If lactate >4 mmol/l, recheck after each 10ml/kg challenge and call Critical Care',
        subDescription: '',
        field: 'mbc',
    },
    {
        number: 6,
        subject: 'MEASURE URINE OUTPUT',
        subtitle: 'May require urinary catheter',
        description: 'Ensure fluid balance chart commenced & completed hourly',
        subDescription: '',
        field: 'balance',
    },
];
const paedsSepsisDict = [
    {
        number: 1,
        subject: 'Give High Flow Oxygen',
        subtitle: '',
        description: '',
        field: 'oxygen',
    },
    {
        number: 2,
        subject: 'Record Blood Pressure and start urine collection (fresh nappy)',
        subtitle: '',
        description: '',
        field: 'balance',
    },
    {
        number: 3,
        subject: 'Obtain iv/io access',
        subtitle: '',
        description: '',
        field: 'ivio',
    },
    {
        number: 4,
        subject: 'Take blood cultures, blood gas (include glucose & lactate)',
        subtitle: '',
        description: '',
        field: 'bloods',
    },
    {
        number: 5,
        subject: 'Give Ceftriaxone 80mg/kg*',
        subtitle: '',
        description: 'Think: If neutropaenic / immunocompromised / neonate, USE local guidance.',
        field: 'mbc',
    },
    {
        number: 6,
        subject: 'Fluid Resuscitation if required: 20ml/kg 0.9% Saline, reassess and repeat as required.',
        subtitle: '',
        description: '',
        field: 'fluids',
    },
];
const paedsAdditionalSepsisDict = [
    {
        number: 1,
        subject: 'HR or RR still above age specific normal range or CRT over3 seconds',
        field: 'hrorrr',
    },
    {
        number: 2,
        subject: 'Venous (or arterial) Lactate over 2',
        field: 'venous',
    },
    {
        number: 3,
        subject: 'Signs of fluid overload ( hepatomegaly, desaturations, crepitations)',
        field: 'fluidoverload',
    },
];

function SepsisPathwayForm(props) {
    const classes = useSepsisFromStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // User
    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);

    const [sepsisPathwayObj, setSepsisPathwayObj] = React.useState(props.sepsisPathObj);
    const [isReasonOpen, openReason, closeReason] = useOpenState(false, true);
    const [reason, setReason] = React.useState(null);
    const [reasonRelatedField, setReasonRelatedField] = React.useState(null);
    const [useSepsisDict, setUseSepsisDict] = React.useState([]);

    const canEditSepsis = dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_MANAGE_SEPSIS])) && !props.disableSave;

    useEffect(() => {
        dispatch(setBlockContext(sepsisPathwayObj.statusObj === SepsisPathwayStatus.INCOMPLETE));
        return () => {
            dispatch(setBlockContext(false));
        };
    }, [sepsisPathwayObj.statusObj]);

    useEffect(() => {
        if (props.sepsisPathObj.paeds) {
            setUseSepsisDict(paedsSepsisDict);
        } else {
            setUseSepsisDict(sepsisDict);
        }
    }, [props.sepsisPathObj.paeds]);

    const setSepsisPathwayField = (field, value, reason, unsetField = null, unsetFieldValue = null) => {
        if ((sepsisPathwayObj.statusObj === SepsisPathwayStatus.INCOMPLETE
            || (props.sepsisPathObj.paeds && sepsisPathwayObj.statusObj !== SepsisPathwayStatus.CANCELED)) && canEditSepsis) {
            let sChangeObj = {...sepsisPathwayObj};
            if (unsetField) {
                _set(sChangeObj, unsetField, unsetFieldValue);
            }
            _set(sChangeObj, field, value);
            _set(sChangeObj, field + 'CheckedBy', tester);
            _set(sChangeObj, field + 'CheckedByLogin', userObject.userName);
            _set(sChangeObj, field + 'CheckedById', userObject.__id);
            _set(sChangeObj, field + 'CheckedByDate', moment().valueOf());
            _set(sChangeObj, field + 'TimeoutDate', null);
            if (reason) {
                if (value == null) {
                    _set(sChangeObj, field + 'UncheckReason', reason);
                    _set(sChangeObj, field + 'UncheckUser', tester);
                    _set(sChangeObj, field + 'UncheckUserLogin', userObject.userName);
                    _set(sChangeObj, field + 'UncheckUserId', userObject.__id);
                } else {
                    _set(sChangeObj, field + 'NAReason', reason);
                }
            }
            setSepsisPathwayObj(sChangeObj);
        }
    };

    const renderSepsisHeader = () => {
        return (
            <div className={classes.headerButtons} id="sepsis-form-header">
                <div>
                    <div>
                        <IconButton
                            className={classes.backButton}
                            onClick={props.closePathwayForm}
                            disabled={sepsisPathwayObj.statusObj === SepsisPathwayStatus.INCOMPLETE}
                        >
                            <ArrowBackIcon/>
                        </IconButton>

                        <span className={classes.sepsisTitle}>
                            {props.sepsisPathObj.paeds ?
                                t('Paediatric Sepsis 6: Achieve the following within 1 hr.') :
                                t('Sepsis Management (Complete within 1 hour)')}
                        </span>
                    </div>

                    {props.sepsisPathObj.paeds &&
                        <div className={classes.sepsisTitle} style={{marginLeft: 45, marginTop: -10}}>
                            {t('Refer to SORT sepsis pathway (www.sort.nhs.uk)')}
                        </div>
                    }

                    <div className={classes.sepsisCreator}>
                        {t('Create by ')} {sepsisPathwayObj?.userCreate} {t(' on ')} {moment(sepsisPathwayObj?.dateCreate).format(config.defaultDateTimeFormat)}
                    </div>

                    {sepsisPathwayObj.userEnd &&
                        <div className={classes.sepsisCreator}>
                            {sepsisPathwayObj.statusObj === SepsisPathwayStatus.CANCELED &&
                                <span>
                                    {t(`Set to 'NOT REQUIRED' by `)} {sepsisPathwayObj?.userEnd} {t(' on ')} {moment(sepsisPathwayObj?.dateEnd).format(config.defaultDateTimeFormat)}
                                </span>
                            }

                            {sepsisPathwayObj.statusObj === SepsisPathwayStatus.ENDED &&
                                <span>
                                    {t('Completed by ')} {sepsisPathwayObj?.userEnd} {t(' on ')} {moment(sepsisPathwayObj?.dateEnd).format(config.defaultDateTimeFormat)}
                                </span>
                            }
                        </div>
                    }
                </div>

                <div style={{marginLeft: 'auto', marginRight: 'auto'}}>
                    {!props.sepsisPathObj.paeds &&
                        <AgyleCheckBox
                            label={t('Neutropenic Sepsis')}
                            onChange={(event) =>
                                setSepsisPathwayObj(prevState => ({
                                    ...prevState,
                                    neutropenic: event.target.checked,
                                }))}
                            disabled={sepsisPathwayObj.statusObj !== SepsisPathwayStatus.INCOMPLETE || !canEditSepsis}
                            value={sepsisPathwayObj.neutropenic}
                        />
                    }
                </div>

                <div className={classes.divRow} style={{paddingTop: 5, marginLeft: 'auto', gap: 6}}>
                    {sepsisPathwayObj.statusObj === SepsisPathwayStatus.INCOMPLETE &&
                        <AgyleButton
                            style={{width: 250}}
                            disabled={!canEditSepsis}
                            onClick={() => {
                                setReasonRelatedField('fullPathway');
                                setReason(null);
                                openReason();
                            }}
                            colour="primary"
                        >
                            {t('Not Required')}
                        </AgyleButton>
                    }

                    {sepsisPathwayObj.statusObj === SepsisPathwayStatus.INCOMPLETE &&
                        <AgyleButton
                            style={{width: '100%'}}
                            disabled={!canEditSepsis}
                            onClick={() => {
                                props.onPathwayChange(false, null, sepsisPathwayObj);
                            }}
                            variant="contained"
                        >
                            {t('Submit')}
                        </AgyleButton>
                    }
                </div>
            </div>
        );
    };

    const getHeight = () => {
        let height = 120;
        let el = document.getElementById('sepsis-form-header');
        if (el) height += el?.offsetHeight;

        return `calc(100vh - ${height}px)`;
    };

    return (
        <>
            <div className={classes.root}>
                {renderSepsisHeader()}
                <div className={'scroll-normal-white'} style={{paddingRight: 5, height: getHeight()}}>
                    <Grid container spacing={2} alignItems="stretch" sx={{pl: 2}} className={classes.rows}>
                        {useSepsisDict.map((sepsisField) => (
                            <SepsisPathwayFormRow
                                key={sepsisField?.number}
                                sepsisField={sepsisField}
                                sepsisPathwayObj={sepsisPathwayObj}
                                canEditSepsis={canEditSepsis}
                                setSepsisPathwayField={setSepsisPathwayField}
                                setReason={setReason}
                                setReasonRelatedField={setReasonRelatedField}
                                openReason={openReason}
                            />
                        ))}
                    </Grid>

                    {props.sepsisPathObj.paeds &&
                        <Grid item xs={12} style={{margin: "10px 0"}}>
                            <InformationBox type={'info'}>
                                <Typography>
                                    {t('Reassess')}
                                </Typography>
                                <div>
                                    {t('Within 1 hour of treatment')}
                                </div>
                            </InformationBox>
                        </Grid>
                    }

                    {props.sepsisPathObj.paeds &&
                        <>
                            <Grid container spacing={2} alignItems="stretch" sx={{pl: 2}} className={classes.rows}>
                                {paedsAdditionalSepsisDict.map((sepsisField) => (
                                    <SepsisPathwayFormRowPaed
                                        key={sepsisField?.number}
                                        sepsisField={sepsisField}
                                        sepsisPathwayObj={sepsisPathwayObj}
                                        setSepsisPathwayField={setSepsisPathwayField}
                                        canEditSepsis={canEditSepsis}
                                    />
                                ))}
                            </Grid>

                            <Grid item xs={12}>
                                <InformationBox type={'error'}>
                                    <div>
                                        {t('If “YES” to ANY of above, Escalate Care to Consultant +/- ITU +/- SORT :02380 775502')}
                                    </div>
                                    <div>
                                        {t('If patient Stabilised – Admit to ward / HDU, review with at least hourly observations for at least 4 hours')}
                                    </div>
                                </InformationBox>
                            </Grid>
                        </>
                    }

                    {(!config?.disablePaedsSepsisPathwayInfoBox && props.sepsisPathObj.paeds) &&
                        <InformationBox type={'warning'}>
                            <p>{t('*If clear source of infection, treat with condition specific antibiotic(s) (consult Microguide)')}</p>
                            <p>{t('In ‘red flag’ sepsis of unknown source or septic shock, give 80mg/kg Ceftriaxone')}</p>
                            <p>{t('<1 month of age, give Cefotaxime iv and Amoxicillin iv')}</p>
                            <p style={{color: '#C33131'}}>{t('In SEVERE or LIFE THREATENING Penicillin allergic patients, give GENTAMICIN (5mg/kg if <1month of age or 7mg/kg if >1month of age, max dose 400mg) AND VANCOMYCIN (15mg/kg)')}</p>
                        </InformationBox>
                    }
                </div>
            </div>

            <AgyleDialog
                onClose={() => {
                    setReasonRelatedField(null);
                    closeReason();
                }}
                open={isReasonOpen}
                title={t('Reason')}
                fullWidth
                onSave={() => {
                    if (reasonRelatedField === 'fullPathway') {
                        props.onPathwayChange(true, reason, sepsisPathwayObj);
                        setReasonRelatedField(null);
                        closeReason();
                    } else {
                        if (sepsisPathwayObj[reasonRelatedField] == null) {
                            setSepsisPathwayField(reasonRelatedField, false, reason);
                        } else {
                            setSepsisPathwayField(reasonRelatedField, null, reason);
                        }
                        setReasonRelatedField(null);
                        closeReason();
                    }
                }}
                disabled={reason == null || reason.length === 0}
            >
                <AgyleTextField
                    label={t('Reason')}
                    placeholder={sepsisPathwayObj[reasonRelatedField] ? t('for get back checked') : ''}
                    multiline
                    minRows={2}
                    value={reason}
                    onChange={(event) => {
                        setReason(event.target.value);
                    }}
                    fullWidth
                    autoFocus
                />
            </AgyleDialog>
        </>
    );
}

export default SepsisPathwayForm;